import { useState, useRef } from 'react';

export default function LicenseKeyInput({ value, onChange, error }) {
  const [groups, setGroups] = useState(value ? value.split('-') : ['', '', '', '']);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleChange = (index, val) => {
    const cleaned = val.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 4);
    const newGroups = [...groups];
    newGroups[index] = cleaned;
    setGroups(newGroups);

    const fullKey = newGroups.join('-');
    onChange(fullKey);

    if (cleaned.length === 4 && index < 3) {
      inputRefs[index + 1].current?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !groups[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').toUpperCase().replace(/[^A-Z0-9]/g, '');
    const newGroups = [];
    for (let i = 0; i < 4; i++) {
      newGroups.push(pasted.slice(i * 4, (i + 1) * 4));
    }
    setGroups(newGroups);
    onChange(newGroups.join('-'));
    const lastFilled = newGroups.findLastIndex(g => g.length > 0);
    if (lastFilled >= 0 && lastFilled < 3) {
      inputRefs[lastFilled + 1].current?.focus();
    }
  };

  return (
    <div>
      <div className="flex items-center justify-center gap-2">
        {groups.map((group, i) => (
          <div key={i} className="flex items-center">
            <input
              ref={inputRefs[i]}
              type="text"
              value={group}
              onChange={(e) => handleChange(i, e.target.value)}
              onKeyDown={(e) => handleKeyDown(i, e)}
              onPaste={i === 0 ? handlePaste : undefined}
              maxLength={4}
              placeholder="XXXX"
              className={`w-20 h-12 text-center font-mono text-[16px] font-semibold text-[#06b6d4] bg-[#151d2e] border-[1.5px] ${
                error ? 'border-red-500' : 'border-[rgba(148,163,184,0.16)]'
              } rounded-lg placeholder-[#475569] outline-none transition-all focus:border-[#06b6d4] focus:shadow-[0_0_0_3px_rgba(6,182,212,0.06)]`}
            />
            {i < 3 && <span className="text-[#475569] text-lg mx-1">-</span>}
          </div>
        ))}
      </div>
      {error && <p className="mt-2 text-[13px] text-red-400 text-center">{error}</p>}
    </div>
  );
}
